import CustomTable from "Component/CustomTable";
import { useState, useEffect, useMemo, useRef } from "react";
import { Notify } from "Component/Notify";
import { fetchApi } from "Config/fetchApi";
import { DraggableModal } from "Component/Modal/index";
import { TablePagination } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "Route/ConstantRoute";
import { EncryptStorage } from "encrypt-storage";
import { handleError } from "Helper";
import { useDispatch, useSelector } from "react-redux";
import { getMasterOrganisasi } from "slice/masterSlice";
import FilterCustemTable from "Component/CustomTable/filterCustemTable";

function UserAccess() {
  const dispatch = useDispatch();
  const {
    datamasterOrganisasi,
    isLoadingmasterOrganisasi,
    errormasterOrganisasi,
  } = useSelector((state) => state.master.master);

  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const userInfo = encryptStorage.getItem("___info");
  const permission_flag =
    userInfo?.permission_flag != undefined
      ? JSON.parse(userInfo?.permission_flag)
      : {};
  const yuridiksi_user_code = userInfo?.jurisdiction_level_code || "";
  const organisasi_user_id = userInfo?.organization_id || "";
  const navigate = useNavigate();
  // ==================== Pengaturan Modal ==================== //
  const [openModal, setOpenModal] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  // ==================== Pengaturan Modal ==================== //
  const [uuid, setUuid] = useState("");
  const [detailData, setDetailData] = useState({});
  const [keywordSearch, setDataKeyword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState([]);
  const [data, setData] = useState([]);
  const isFiltersInitialized = useRef(false);
  const [headerTable] = useState([
    {
      label: "Nama Lengkap",
      key: "user_full_name",
      align: "left",
    },
    {
      label: "Email",
      key: "email",
      align: "left",
    },
    {
      label: "Organisasi",
      key: "user_organization_name",
      align: "left",
    },
    {
      label: "Izin Akses",
      key: "user_permission_name",
      align: "center",
    },
  ]);
  const [isActionTable] = useState({
    isAdd: permission_flag?.user?.addData || false,
    isEdit: permission_flag?.user?.updateData || false,
    isShow: true,
    isDelete: permission_flag?.user?.deleteData || false,
  });
  // ==================== Pengaturan Pagination ==================== //
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  // ==================== Pengaturan Pagination ==================== //

  const datafilters = useMemo(() => {
    const baseFilters = [];

    if (yuridiksi_user_code === "N") {
      baseFilters.push({
        key: "organisasiPenanggungJawab",
        label: "Organisasi Penanggung Jawab",
        isLoading: false,
        options: [],
        multiple: false,
        value: null,
      });
    }

    return baseFilters;
  }, [yuridiksi_user_code]);

  // ==================== Default ==================== //
  const handleSuccess = (message) => {
    Notify.success({
      title: "Berhasil",
      description: message,
    });
  };

  const getData = async () => {
    try {
      setIsLoading(true);

      const valueOrganisasi =
        filters[0]?.value?.value === undefined ? "" : filters[0]?.value?.value;

      const paramCari = `keywords=${keywordSearch}`;
      const paramPage = `page=${pageNumber}`;
      const paramSize = `size=${pageSize}`;
      const organizationParam = `organizationId=${yuridiksi_user_code === "N" ? valueOrganisasi : organisasi_user_id}`;
      const response = await fetchApi().get(
        `/auth/get-list?${paramCari}&${organizationParam}&${paramPage}&${paramSize}`
      );
      // auth/get-list?keywords=&organizationId=&page=0&size=15

      setData(response?.data || {});
      setPageNumber(response.data?.currentPage || 0);
      setPageSize(response.data?.size || 15);
      setIsLoading(false);
    } catch (err) {
      setData([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  const deleteData = async () => {
    try {
      setIsLoading(true);
      const response = await fetchApi().delete(`/auth/delete/${uuid}`);
      setIsLoading(false);
      handleSuccess(response.data?.message);
      getData();
      setOpenModalDelete(!openModalDelete);
    } catch (err) {
      setOpenModalDelete(!openModalDelete);
      setIsLoading(false);
      handleError(err);
    }
  };
  // ==================== Default ==================== //

  useEffect(() => {
    if (isFiltersInitialized.current) {
      getData();
    }
  }, [keywordSearch, pageNumber, pageSize, filters]);

  useEffect(() => {
    dispatch(getMasterOrganisasi());
  }, []);

  // useEffect(() => {
  //   if (datafilters.length > 0) {
  //     const mapped = datafilters.map((f) => ({
  //       ...f,
  //       value: f.multiple ? [] : null,
  //     }));
  //     setFilters(mapped);
  //     // isFiltersInitialized.current = true;
  //   }
  // }, [datafilters]);

  useEffect(() => {
    if (
      datafilters.length > 0 &&
      datamasterOrganisasi?.length > 0 &&
      !isFiltersInitialized.current
    ) {
      const mapped = datafilters.map((f) => {
        let options = [];
        let isLoading = false;

        if (f.key === "organisasiPenanggungJawab") {
          options = datamasterOrganisasi.map((s) => ({
            label: s?.organization_name,
            value: s?.id,
          }));
          isLoading = isLoadingmasterOrganisasi;
        }

        return {
          ...f,
          value: f.multiple ? [] : null,
          options,
          isLoading,
        };
      });

      setFilters(mapped);
      isFiltersInitialized.current = true;
    }
  }, [datafilters, datamasterOrganisasi, isLoadingmasterOrganisasi]);

  const handleFilterChange = (key, newValue) => {
    setFilters((prev) =>
      prev.map((f) => (f.key === key ? { ...f, value: newValue } : f))
    );
  };
  // ==================== Default ==================== //

  return (
    <div>
      <div className="text-lg font-bold text-start gap-2 pb-5">
        <p
          className="text-2xl font-bold"
          style={{
            fontFamily: "Poppins",
          }}
        >
          Pengguna
        </p>
      </div>

      <FilterCustemTable
        filtersConfig={datafilters}
        filters={filters?.length === 0 ? datafilters : filters}
        handleFilterChange={handleFilterChange}
        sxCustem={(f) => (f?.key === "organisasiPenanggungJawab" ? 300 : 200)}
        onClickCreate={() =>
          navigate(ROUTES.management_data.user_access.user_access_create)
        }
        isAction={isActionTable}
        onEditData={(data) =>
          navigate(ROUTES.management_data.user_access.user_access_update, {
            state: data,
          })
        }
        onClickShow={(data) => {
          setDetailData(data);
          setOpenModal(!openModal);
        }}
        onDeleteData={(data) => {
          setUuid(data?.id);
          setDetailData(data);
          setOpenModalDelete(!openModalDelete);
        }}
        isLoading={data?.data === undefined ? true : isLoading}
        onRefresh={() => {
          setDataKeyword(keywordSearch);
          setPageSize(pageSize);
          setPageNumber(pageNumber);
        }}
        headerData={headerTable}
        Data={data?.data || []}
        onSearchData={(keyword) => {
          setDataKeyword(keyword);
        }}
        rowsPerPage={pageSize}
        page={pageNumber}
        TablePagination={
          <TablePagination
            rowsPerPageOptions={[5, 15, 30, 50]}
            component="div"
            count={data?.pageInfo?.totalItems || 0}
            rowsPerPage={pageSize}
            page={pageNumber}
            onPageChange={(event, newPage) => setPageNumber(newPage)}
            onRowsPerPageChange={(event) => {
              setPageSize(parseInt(event.target.value, 10));
              setPageNumber(0);
            }}
          />
        }
      />

      {/* Modal Detail Data */}
      <DraggableModal size="md" open={openModal} toggleModal={() => {}}>
        <DraggableModal.Header className="capitalize">
          <div className="flex gap-4 items-center justify-between">
            <p className="text-2xl font-bold" style={{ fontFamily: "Poppins" }}>
              Detail Data
            </p>
            <button
              className="h-10 flex w-auto justify-center items-center rounded-xl hover:bg-neutral-100 px-3 py-1.5 text-xl font-semibold leading-6 text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              onClick={() => setOpenModal(false)}
            >
              <i className="ri-close-line"></i>
            </button>
          </div>
        </DraggableModal.Header>

        <DraggableModal.Body>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 py-5 px-5">
            {/* Nama Lengkap */}
            <div>
              <label
                className="text-sm block font-bold leading-6"
                style={{ fontFamily: "Poppins" }}
              >
                Nama Lengkap
              </label>
              <p
                className="text-md font-medium"
                style={{ fontFamily: "Poppins" }}
              >
                {detailData?.user_full_name || "-"}
              </p>
            </div>

            {/* Email */}
            <div>
              <label
                className="text-sm block font-bold leading-6"
                style={{ fontFamily: "Poppins" }}
              >
                Email
              </label>
              <p
                className="text-md font-medium break-words"
                style={{ fontFamily: "Poppins" }}
              >
                {detailData?.email || "-"}
              </p>
            </div>

            {/* Nomor Handphone */}
            <div>
              <label
                className="text-sm block font-bold leading-6"
                style={{ fontFamily: "Poppins" }}
              >
                Nomor Handphone
              </label>
              <p
                className="text-md font-medium"
                style={{ fontFamily: "Poppins" }}
              >
                {detailData?.phone || "-"}
              </p>
            </div>

            {/* Jenis Kelamin */}
            <div>
              <label
                className="text-sm block font-bold leading-6"
                style={{ fontFamily: "Poppins" }}
              >
                Jenis Kelamin
              </label>
              <p
                className="text-md font-medium"
                style={{ fontFamily: "Poppins" }}
              >
                {detailData?.user_gender_name || "-"}
              </p>
            </div>

            {/* Organisasi */}
            <div>
              <label
                className="text-sm block font-bold leading-6"
                style={{ fontFamily: "Poppins" }}
              >
                Organisasi
              </label>
              <p
                className="text-md font-medium"
                style={{ fontFamily: "Poppins" }}
              >
                {detailData?.user_organization_name || "-"}
              </p>
            </div>

            {/* Izin Akses */}
            <div>
              <label
                className="text-sm block font-bold leading-6"
                style={{ fontFamily: "Poppins" }}
              >
                Izin Akses
              </label>
              <p
                className="text-md font-medium"
                style={{ fontFamily: "Poppins" }}
              >
                {detailData?.user_permission_name || "-"}
              </p>
            </div>

            {/* Status Akun */}
            <div>
              <label
                className="text-sm block font-bold leading-6"
                style={{ fontFamily: "Poppins" }}
              >
                Status Akun Pengguna
              </label>
              <p
                className="text-md font-medium"
                style={{ fontFamily: "Poppins" }}
              >
                {detailData?.active !== undefined
                  ? detailData?.active === true
                    ? "Aktif"
                    : "Tidak Aktif"
                  : "-"}
              </p>
            </div>
          </div>
        </DraggableModal.Body>

        <DraggableModal.Footer>
          <div className="flex gap-4 items-center justify-end">
            <button
              onClick={() => setOpenModal(false)}
              className="h-11 flex w-auto justify-center items-center rounded-xl bg-btn-login hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Tutup
            </button>
          </div>
        </DraggableModal.Footer>
      </DraggableModal>

      {/* Modal Confirm Delete */}
      <DraggableModal size="sm" open={openModalDelete} toggleModal={() => {}}>
        <DraggableModal.Header className="capitalize">
          <div className="flex gap-4 items-center justify-between">
            <p
              className="text-2xl font-bold"
              style={{
                fontFamily: "Poppins",
              }}
            >
              Hapus Data
            </p>
            <button
              className="h-10 flex w-auto justify-center items-center rounded-xl hover:bg-neutral-100 px-3 py-1.5 text-xl font-semibold leading-6 text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              onClick={() => setOpenModalDelete(!openModalDelete)}
            >
              <i className="ri-close-line"></i>
            </button>
          </div>
        </DraggableModal.Header>
        <DraggableModal.Body>
          <div className="w-full text-lg font-bold text-start">
            <p
              className="text-md font-medium"
              style={{
                fontFamily: "Poppins",
              }}
            >
              Apakah Anda yakin ingin menghapus data{" "}
              {detailData?.user_full_name || "-"}?
            </p>
          </div>
        </DraggableModal.Body>
        <DraggableModal.Footer>
          <div className="flex gap-4 items-center justify-end">
            <button
              className="h-11 flex w-auto justify-center items-center rounded-xl hover:bg-neutral-100 px-3 py-1.5 text-sm font-semibold leading-6 text-black  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              onClick={() => setOpenModalDelete(!openModalDelete)}
            >
              Tutup
            </button>
            <button
              onClick={deleteData}
              className="h-11 flex w-auto justify-center items-center rounded-xl bg-rose-900 hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Hapus
            </button>
          </div>
        </DraggableModal.Footer>
      </DraggableModal>
    </div>
  );
}

export default UserAccess;
